import { defineAction } from '~/prix'
import { z } from 'zod'
import residenceDocumentFetchAction from './residenceDocumentFetch.action.json' with { type: 'json' }
import { residenceDocumentObject } from '../residenceDocumentObject'

const residenceDocumentFetchDefinition = defineAction({
  ...residenceDocumentFetchAction,

  input: z.object({
    id: residenceDocumentObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: residenceDocumentObject,
})

export default residenceDocumentFetchDefinition
